import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=11d3b45e&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=11d3b45e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d3b45e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11d3b45e')) {
      api.createRecord('11d3b45e', component.options)
    } else {
      api.reload('11d3b45e', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=11d3b45e&scoped=true&", function () {
      api.rerender('11d3b45e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Kls9zZvLYDWC/JS/comp/PopupBox.vue"
export default component.exports